import hostelHeroImage from "../../assets/hotels1.png";
import hostelBuildingImage from "../../assets/38ef71f7f158e89e803225ed66fc5af0e3e6bdc3.png";
import sravikAshramRoomImage from "../../assets/e87bc0ebce4f04d972a3c1f9e5d8e1f627718556.png";

export interface Hostel {
  id: number;
  name: string;
  address: string;
  city: string;
  state: string;
  city_name?: string;
  state_name?: string;
  capacity: number;
  type: string;
  facilities: string[];
  fees: string;
  scholarship: boolean;
  sicRating: number;
  image: string;
  trust: string;
  safetyRating: number;
  hygieneRating: number;
  academicSupport: number;
  culturalAlignment: number;
  governance: number;
}

// Mock hostel data
export const hostels: Hostel[] = [
  {
    id: 1,
    name: "Sheth Hirachand Gumanji Jain Boarding",
    address:
      "Navjivan society area, near Tardeo bridge, grant road east, mumbai-07",
    city: "Mumbai",
    state: "Maharashtra",
    capacity: 90,
    type: "Boys",
    facilities: ["Library", "Gym", "Mess", "Wi-Fi", "Study Room"],
    fees: "₹8,000/month",
    scholarship: true,
    sicRating: 4.5,
    image: hostelBuildingImage,
    trust: "Karnataka Jain Education Trust",
    safetyRating: 4.5,
    hygieneRating: 4.8,
    academicSupport: 4.2,
    culturalAlignment: 4.7,
    governance: 4.6,
  },
  {
    id: 2,
    name: "Shri Siddhkshetra Sravika Ashram",
    address: "Palitana, Gujarat",
    city: "Palitana",
    state: "Gujarat",
    capacity: 200,
    type: "Girls",
    facilities: ["Library", "Mess", "Wi-Fi", "Security", "Medical"],
    fees: "₹10,000/month",
    scholarship: true,
    sicRating: 4.7,
    image: sravikAshramRoomImage,
    trust: "Mumbai Jain Samaj",
    safetyRating: 4.8,
    hygieneRating: 4.6,
    academicSupport: 4.5,
    culturalAlignment: 4.9,
    governance: 4.7,
  },
  {
    id: 3,
    name: "Jain Student Residence",
    address: "Malviya Nagar, Jaipur",
    city: "Jaipur",
    state: "Rajasthan",
    capacity: 100,
    type: "Co-Ed",
    facilities: ["Library", "Gym", "Mess", "Wi-Fi", "Coaching"],
    fees: "₹7,000/month",
    scholarship: true,
    sicRating: 4.3,
    image: hostelHeroImage,
    trust: "Rajasthan Jain Welfare Society",
    safetyRating: 4.2,
    hygieneRating: 4.4,
    academicSupport: 4.6,
    culturalAlignment: 4.5,
    governance: 4.4,
  },
];
